import classNames from 'classnames';
import { PUBLIC_URL } from '../../config';
import { useCallback, useMemo, useState } from 'react';

interface ILogoIconProps {
    className?: string,
    onClick?: () => void
}

function LogoIcon(props: ILogoIconProps) {
    const { className, onClick } = props;

    const [useDefaultImg, setUseDefaultImg] = useState(false);
    const [loading, setLoading] = useState(true);

    const onErrorHandler = useCallback((e) => {
        e.preventDefault();
        setUseDefaultImg(true);
    }, []);

    const onLoadHandler = useCallback(() => setLoading(false), []);

    const appName = useMemo(() => {
        const list = window.location.hostname.split('.');
        const hostname = list.length > 1
            ? `${list[list.length - 2]}.${list[list.length - 1]}`
            : list[0];
        return useDefaultImg ? 'default' : hostname;
    }, [useDefaultImg]);

    return <img
        className={classNames(className, { 'd-none': loading })}
        onClick={onClick}
        onLoad={onLoadHandler}
        onError={onErrorHandler}
        src={`${PUBLIC_URL}/assets/apps/${appName}/logo.svg`}
    />
}

export default LogoIcon;
